"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  FONT_FAMILY_NAMES: () => FONT_FAMILY_NAMES,
  LOCALES_WITH_INTERNATIONAL_FONTS: () => LOCALES_WITH_INTERNATIONAL_FONTS,
  getFontByLocale: () => getFontByLocale,
  injectFont: () => injectFont,
  injectFontAwesome: () => injectFontAwesome,
  loadFonts: () => loadFonts
});
module.exports = __toCommonJS(src_exports);

// src/constants.ts
var FONT_FAMILY_NAMES = [
  "Figtree",
  // Primary Font
  "Noto Sans",
  // Fallback
  "Barlow Semi Condensed Semibold",
  // For headings, low priority
  "Barlow Semi Condensed Medium",
  // For headings, low priority
  '"FontAwesome"',
  // Icons, low priority
  '"Font Awesome 6 Brands"',
  // Icons, low priority
  '"Font Awesome 6 Duotone"',
  // Icons, low priority
  '"Font Awesome 6 Kit"',
  // Custom Icons, low priority
  '"Font Awesome 6 Pro"'
  // Icons, low priority
];
var LOCALES_WITH_INTERNATIONAL_FONTS = [
  "ar-SA",
  "fa-AF",
  "fa-IR",
  "ps-AF",
  "ur-PK",
  "bn-BD",
  "dv-MV",
  "he-IL",
  "hi-IN",
  "mr-IN",
  "ne-NP",
  "hy-AM",
  "ja-JP",
  "ka-GE",
  "kn-IN",
  "km-KH",
  "ko-KR",
  "my-MM",
  "si-LK",
  "ta-IN",
  "te-IN",
  "th-TH",
  "zh-CN",
  "zh-TW"
];
function loadFonts(fonts = FONT_FAMILY_NAMES) {
  const fontsToLoad = fonts.map((font) => `1rem ${font}`);
  return Promise.all([
    // Load individual fonts
    ...fontsToLoad.map((font) => document.fonts.load(font)),
    document.fonts.ready
  ]);
}

// src/resolver/getFontByLocale.ts
function getFontByLocale(locale) {
  switch (locale) {
    case "ar-SA":
      return import("@code-dot-org/fonts/locales/ar-SA/index.module.css");
    case "fa-AF":
      return import("@code-dot-org/fonts/locales/fa-AF/index.module.css");
    case "fa-IR":
      return import("@code-dot-org/fonts/locales/fa-IR/index.module.css");
    case "ps-AF":
      return import("@code-dot-org/fonts/locales/ps-AF/index.module.css");
    case "ur-PK":
      return import("@code-dot-org/fonts/locales/ur-PK/index.module.css");
    case "bn-BD":
      return import("@code-dot-org/fonts/locales/bn-BD/index.module.css");
    case "dv-MV":
      return import("@code-dot-org/fonts/locales/dv-MV/index.module.css");
    case "he-IL":
      return import("@code-dot-org/fonts/locales/he-IL/index.module.css");
    case "hi-IN":
      return import("@code-dot-org/fonts/locales/hi-IN/index.module.css");
    case "mr-IN":
      return import("@code-dot-org/fonts/locales/mr-IN/index.module.css");
    case "ne-NP":
      return import("@code-dot-org/fonts/locales/ne-NP/index.module.css");
    case "hy-AM":
      return import("@code-dot-org/fonts/locales/hy-AM/index.module.css");
    case "ja-JP":
      return import("@code-dot-org/fonts/locales/ja-JP/index.module.css");
    case "ka-GE":
      return import("@code-dot-org/fonts/locales/ka-GE/index.module.css");
    case "kn-IN":
      return import("@code-dot-org/fonts/locales/kn-IN/index.module.css");
    case "km-KH":
      return import("@code-dot-org/fonts/locales/km-KH/index.module.css");
    case "ko-KR":
      return import("@code-dot-org/fonts/locales/ko-KR/index.module.css");
    case "my-MM":
      return import("@code-dot-org/fonts/locales/my-MM/index.module.css");
    case "si-LK":
      return import("@code-dot-org/fonts/locales/si-LK/index.module.css");
    case "ta-IN":
      return import("@code-dot-org/fonts/locales/ta-IN/index.module.css");
    case "te-IN":
      return import("@code-dot-org/fonts/locales/te-IN/index.module.css");
    case "th-TH":
      return import("@code-dot-org/fonts/locales/th-TH/index.module.css");
    case "zh-CN":
      return import("@code-dot-org/fonts/locales/zh-CN/index.module.css");
    case "zh-TW":
      return import("@code-dot-org/fonts/locales/zh-TW/index.module.css");
    default:
      return Promise.resolve(false);
  }
}

// src/loader/index.ts
function injectFont(locale) {
  getFontByLocale(locale).then((fontClassName) => {
    const fontMount = document.createElement("div");
    fontMount.className = fontClassName;
    document.head.appendChild(fontMount);
  });
}
function injectFontAwesome() {
  const stylesheets = [
    "https://dsco.code.org/assets/font-awesome-pro/1728421354/css/fontawesome.min.css",
    "https://dsco.code.org/assets/font-awesome-pro/1728421354/css/brands.min.css",
    "https://dsco.code.org/assets/font-awesome-pro/1728421354/css/solid.min.css",
    "https://dsco.code.org/assets/font-awesome-pro/1728421354/css/regular.min.css",
    "https://dsco.code.org/assets/font-awesome-pro/1728421354/css/v4-font-face.min.css",
    "https://dsco.code.org/assets/font-awesome-pro/1728421354/css/v4-shims.min.css",
    "https://dsco.code.org/assets/font-awesome-pro/1728421354/css/duotone.min.css",
    "https://dsco.code.org/assets/font-awesome-pro/1728421354/css/custom-icons.min.css"
  ];
  stylesheets.forEach((stylesheetHref) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = stylesheetHref;
    document.head.appendChild(link);
  });
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  FONT_FAMILY_NAMES,
  LOCALES_WITH_INTERNATIONAL_FONTS,
  getFontByLocale,
  injectFont,
  injectFontAwesome,
  loadFonts
});
//# sourceMappingURL=index.js.map